import { LeftRight } from '@bscom/content-blocks/NewBrandLeftRight';

import { Box, BoxProps } from '@bscom/components/Box';
import { ExternalSignupForm } from 'components/ExternalSignupForm';
import { ILeftRightRichText } from '@bscom/types';

const SignupFormWrapper = (props: BoxProps) => (
  <Box
    py={[5, , , 8]}
    px={[6, , , 8]}
    m={[4, , , 0]}
    bg="white"
    borderRadius="32px"
    {...props}
  />
);

const customModules = {
  pageSignup: () => (
    <SignupFormWrapper>
      <ExternalSignupForm />
    </SignupFormWrapper>
  ),
};

const LeftRightWithSignup = (props: ILeftRightRichText) => {
  return <LeftRight customModules={customModules} {...props} />;
};

export default LeftRightWithSignup;
